import {
  CREATE_PROJECT_INIT,
  CREATE_PROJECT_SUCCESS,
  CREATE_PROJECT_FAILED,
  GET_PROJECT_ANALYTICS_INIT,
  GET_PROJECT_ANALYTICS_SUCCESS,
  GET_PROJECT_ANALYTICS_FAILED,
  GET_NO_PROJECTS_BY_TYPE_INIT,
  GET_NO_PROJECTS_BY_TYPE_SUCCESS,
  GET_NO_PROJECTS_BY_TYPE_FAILED,
  GET_OVERALL_PROGRESS_INIT,
  GET_OVERALL_PROGRESS_SUCCESS,
  GET_OVERALL_PROGRESS_FAILED,
  GET_PROJECT_DETAILS_BY_ID_INIT,
  GET_PROJECT_DETAILS_BY_ID_SUCCESS,
  GET_PROJECT_DETAILS_BY_ID_FAILED,
  UPDATE_PROJECT_DETAILS_BY_ID_INIT,
  UPDATE_PROJECT_DETAILS_BY_ID_SUCCESS,
  UPDATE_PROJECT_DETAILS_BY_ID_FAILED,
  GET_PROJECT_KANBAN_VIEW_INIT,
  GET_PROJECT_KANBAN_VIEW_SUCCESS,
  GET_PROJECT_KANBAN_VIEW_FAILED,
  GET_PROJECT_KANBAN_RESOURCE_INIT,
  GET_PROJECT_KANBAN_RESOURCE_SUCCESS,
  GET_PROJECT_KANBAN_RESOURCE_FAILED,
  ADD_RESOURCE_INIT,
  ADD_RESOURCE_SUCCESS,
  ADD_RESOURCE_FAILED,
  REMOVE_RESOURCE_INIT,
  REMOVE_RESOURCE_SUCCESS,
  REMOVE_RESOURCE_FAILED,
  GET_ADD_RESOURCE_INIT,
  GET_ADD_RESOURCE_SUCCESS,
  GET_ADD_RESOURCE_FAILED,
  GET_PROJECTS_LIST_INIT,
  GET_PROJECTS_LIST_SUCCESS,
  GET_PROJECTS_LIST_FAILED,
  GET_RESOURCE_BY_ID_INIT,
  GET_RESOURCE_BY_ID_SUCCESS,
  GET_RESOURCE_BY_ID_FAILED,
  GET_PL_STATEMENT_BUDGET_INIT,
  GET_PL_STATEMENT_BUDGET_SUCCESS,
  GET_PL_STATEMENT_BUDGET_FAILED,
  GET_PL_STATEMENT_FORECAST_INIT,
  GET_PL_STATEMENT_FORECAST_SUCCESS,
  GET_PL_STATEMENT_FORECAST_FAILED,
  GET_BUDGET_FORECAST_INIT,
  GET_BUDGET_FORECAST_SUCCESS,
  GET_BUDGET_FORECAST_FAILED,
  GET_BREAKDOWN_CHART_INIT,
  GET_BREAKDOWN_CHART_SUCCESS,
  GET_BREAKDOWN_CHART_FAILED,
  GET_TOTAL_COST_INIT,
  GET_TOTAL_COST_SUCCESS,
  GET_TOTAL_COST_FAILED,
  GET_TOTAL_BUDGET_INIT,
  GET_TOTAL_BUDGET_SUCCESS,
  GET_TOTAL_BUDGET_FAILED,
  ADD_RESOURCE_REQUESTS_INIT,
  ADD_RESOURCE_REQUESTS_SUCCESS,
  ADD_RESOURCE_REQUESTS_FAILED,
  DOWNLOAD_PROJECT_ANALYTICS_INIT,
  DOWNLOAD_PROJECT_ANALYTICS_SUCCESS,
  DOWNLOAD_PROJECT_ANALYTICS_FAILED,
  GET_NAMED_RESOURCES_ALLOCATIONS_INIT,
  GET_NAMED_RESOURCES_ALLOCATIONS_SUCCESS,
  GET_NAMED_RESOURCES_ALLOCATIONS_FAILED,
  GET_UNNAMED_RESOURCES_ALLOCATIONS_INIT,
  GET_UNNAMED_RESOURCES_ALLOCATIONS_SUCCESS,
  GET_UNNAMED_RESOURCES_ALLOCATIONS_FAILED,
  UPDATE_NAMED_RESOURCES_ALLOCATIONS_INIT,
  UPDATE_NAMED_RESOURCES_ALLOCATIONS_SUCCESS,
  UPDATE_NAMED_RESOURCES_ALLOCATIONS_FAILED,
  UPDATE_UNNAMED_RESOURCES_ALLOCATIONS_INIT,
  UPDATE_UNNAMED_RESOURCES_ALLOCATIONS_SUCCESS,
  UPDATE_UNNAMED_RESOURCES_ALLOCATIONS_FAILED,
  ADD_TO_PROJECT_NAMED_INIT,
  ADD_TO_PROJECT_NAMED_SUCCESS,
  ADD_TO_PROJECT_NAMED_FAILED,
  ADD_TO_PROJECT_UNNAMED_INIT,
  ADD_TO_PROJECT_UNNAMED_SUCCESS,
  ADD_TO_PROJECT_UNNAMED_FAILED,
  GET_REQUEST_RESOURCES_BY_FILTERS_INIT,
  GET_REQUEST_RESOURCES_BY_FILTERS_SUCCESS,
  GET_REQUEST_RESOURCES_BY_FILTERS_FAILED,
  GET_REQUEST_RESOURCES_BY_FILTERS_BY_RM_INIT,
  GET_REQUEST_RESOURCES_BY_FILTERS_BY_RM_SUCCESS,
  GET_REQUEST_RESOURCES_BY_FILTERS_BY_RM_FAILED,
  GET_DOWNLOAD_CREATE_PROJECT_INIT,
  GET_DOWNLOAD_CREATE_PROJECT_SUCCESS,
  GET_DOWNLOAD_CREATE_PROJECT_FAILED,
  CREATE_PROJECT_FROM_EXCEL_INIT,
  CREATE_PROJECT_FROM_EXCEL_SUCCESS,
  CREATE_PROJECT_FROM_EXCEL_FAILED,
  CLEAR_PM_LANDING_DATA,
  CLEAR_PM_DETAILS_DATA,
  CLEAR_PM_NAMED_DETAILS_DATA,
  CLEAR_PM_UNNAMED_DETAILS_DATA,
  UPDATE_FAVOURITE_STATUS_INIT,
  UPDATE_FAVOURITE_STATUS_SUCCESS,
  UPDATE_FAVOURITE_STATUS_FAILED,
  SHOW_NAMED_UNNAMED_BUTTON_INIT,
  SHOW_NAMED_UNNAMED_BUTTON_SUCCESS,
  SHOW_NAMED_UNNAMED_BUTTON_FAILED,
  COMPLIANCE_REPORT_PROJECT_INIT,
  COMPLIANCE_REPORT_PROJECT_SUCCESS,
  COMPLIANCE_REPORT_PROJECT_FAILED,
  DOWNLOAD_COMPLIANCE_REPORT_PROJECT_INIT,
  DOWNLOAD_COMPLIANCE_REPORT_PROJECT_SUCCESS,
  DOWNLOAD_COMPLIANCE_REPORT_PROJECT_FAILED,
  GET_ADMIN_SUPPORT_ACTIVITIES_INIT,
  GET_ADMIN_SUPPORT_ACTIVITIES_SUCCESS,
  GET_ADMIN_SUPPORT_ACTIVITIES_FAILED,
  UPDATE_ADMIN_SUPPORT_ACTIVITIES_INIT,
  UPDATE_ADMIN_SUPPORT_ACTIVITIES_SUCCESS,
  UPDATE_ADMIN_SUPPORT_ACTIVITIES_FAILED,
  DOWNLOAD_ADMIN_SUPPORT_ACTIVITIES_INIT,
  DOWNLOAD_ADMIN_SUPPORT_ACTIVITIES_SUCCESS,
  DOWNLOAD_ADMIN_SUPPORT_ACTIVITIES_FAILED,
  UPDATE_ADMIN_SUPPORT_RESOURCE_ACTIVITIES_INIT,
  UPDATE_ADMIN_SUPPORT_RESOURCE_ACTIVITIES_SUCCESS,
  UPDATE_ADMIN_SUPPORT_RESOURCE_ACTIVITIES_FAILED,
  ACCEPT_PROJECT_REQUEST_INIT,
  ACCEPT_PROJECT_REQUEST_SUCCESS,
  ACCEPT_PROJECT_REQUEST_FAILED,
  GET_NAMED_ALLOCATIONS_BY_MAPID_INIT,
  GET_NAMED_ALLOCATIONS_BY_MAPIDT_SUCCESS,
  GET_NAMED_ALLOCATIONS_BY_MAPID_FAILED,
  DOWNLOAD_FILTERED_PROJECT_ANALYTICS_INIT,
  DOWNLOAD_FILTERED_PROJECT_ANALYTICS_SUCCESS,
  DOWNLOAD_FILTERED_PROJECT_ANALYTICS_FAILED,
  DOWNLOAD_PROJECT_RESOURCE_DATA_INIT,
  DOWNLOAD_PROJECT_RESOURCE_DATA_SUCCESS,
  DOWNLOAD_PROJECT_RESOURCE_DATA_FAILED,
} from "./types/project-management-types";
import {
  createProjectAPI,
  getProjectAnalyticsAPI,
  getNoOfProjectsByTypeAPI,
  getOverAllProgressAPI,
  getProjectDetailsByIdAPI,
  updateProjectDetailsByIdAPI,
  getKanbanDataAPI,
  getKanbanResourceDataAPI,
  addResourceAPI,
  removeResourceAPI,
  getAddResourceBySkillRoleIdAPI,
  getProjectListAPI,
  getResourceByResourceIdAPI,
  getPLStatementBudgetAPI,
  getPLStatementForecastAPI,
  getBudgetVsForecastAPI,
  getBreakdownChartAPI,
  getTotalCostAPI,
  getTotalBudgetAPI,
  addResourceRequestsAPI,
  downloadProjectAnalyticsAPI,
  getNamedAllocatedResourceDetailsAPI,
  getUnnamedAllocatedResourceDetailsAPI,
  updateNamedAllocatedResourceDetailsAPI,
  updateUnnamedAllocatedResourceDetailsAPI,
  addToProjectNamedAPI,
  addToProjectUnnamedAPI,
  getRequestResourceByFiltersAPI,
  getRequestResourceByFiltersByRMAPI,
  getDownloadCreateProjectExcelFileAPI,
  createProjectFromExcelAPI,
  updateProjectFavoritesStatusAPI,
  showAddNamedUnnamedResourceButtonsAPI,
  downloadResourceDelinquenciesReportAPI,
  getResourceDelinquenciesReportAPI,
  getAdminSupportActivitiesTableAPI,
  createUpdateAdminSupportActivityAPI,
  downloadAdminSupportActivityAPI,
  createUpdateResourceAdminSupportActivityAPI,
  getNamedAllocatedResourceDetailsByMapIdAPI,
  acceptCompleteResourceRequestAPI,
  downloadFilteredProjectAnalyticsAPI,
  downloadProjectAllAllocationDataChartAPI,
} from "../api/project-management-api";
import { COMPLIANCE_REPORT_RESOURCE_INIT } from "./types/resource-management-types";
import {
  GET_USER_ACCESS_CHART_INIT,
  USER_ACCESS_REPORT_INIT,
} from "./types/admin-types";

export function createProject(body) {
  return (dispatch) => {
    dispatch({ type: CREATE_PROJECT_INIT });
    createProjectAPI(body)
      .then((response) => dispatch({ type: CREATE_PROJECT_SUCCESS, response }))
      .catch((error) => dispatch({ type: CREATE_PROJECT_FAILED, error }));
  };
}

export function getProjectAnalytics(body, myView, showInactiveProjects) {
  return (dispatch) => {
    dispatch({ type: GET_PROJECT_ANALYTICS_INIT });
    getProjectAnalyticsAPI(body, myView, showInactiveProjects)
      .then((response) =>
        dispatch({ type: GET_PROJECT_ANALYTICS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_PROJECT_ANALYTICS_FAILED, error })
      );
  };
}

export function getNoOfProjectsByType(body, myView, showInactiveProjects) {
  return (dispatch) => {
    dispatch({ type: GET_NO_PROJECTS_BY_TYPE_INIT });
    getNoOfProjectsByTypeAPI(body, myView, showInactiveProjects)
      .then((response) =>
        dispatch({ type: GET_NO_PROJECTS_BY_TYPE_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_NO_PROJECTS_BY_TYPE_FAILED, error })
      );
  };
}

export function getOverAllProgress(body, myView, showInactiveProjects) {
  return (dispatch) => {
    dispatch({ type: GET_OVERALL_PROGRESS_INIT });
    getOverAllProgressAPI(body, myView, showInactiveProjects)
      .then((response) =>
        dispatch({ type: GET_OVERALL_PROGRESS_SUCCESS, response })
      )
      .catch((error) => dispatch({ type: GET_OVERALL_PROGRESS_FAILED, error }));
  };
}

export function clearPMLanding() {
  return (dispatch) => {
    dispatch({ type: CLEAR_PM_LANDING_DATA });
  };
}

export function clearPMDetails() {
  return (dispatch) => {
    dispatch({ type: CLEAR_PM_DETAILS_DATA });
  };
}

export function clearPMNamedDetails() {
  return (dispatch) => {
    dispatch({ type: CLEAR_PM_NAMED_DETAILS_DATA });
  };
}

export function clearPMUnnamedDetails() {
  return (dispatch) => {
    dispatch({ type: CLEAR_PM_UNNAMED_DETAILS_DATA });
  };
}

export function getProjectDetailsById(id) {
  return (dispatch) => {
    dispatch({ type: GET_PROJECT_DETAILS_BY_ID_INIT });
    getProjectDetailsByIdAPI(id)
      .then((response) =>
        dispatch({ type: GET_PROJECT_DETAILS_BY_ID_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_PROJECT_DETAILS_BY_ID_FAILED, error })
      );
  };
}

export function updateProjectDetailsById(body, id, forceDeallocateResources) {
  return (dispatch) => {
    dispatch({ type: UPDATE_PROJECT_DETAILS_BY_ID_INIT });
    updateProjectDetailsByIdAPI(body, id, forceDeallocateResources)
      .then((response) =>
        dispatch({ type: UPDATE_PROJECT_DETAILS_BY_ID_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_PROJECT_DETAILS_BY_ID_FAILED, error })
      );
  };
}

export function getKanbanData(id) {
  return (dispatch) => {
    dispatch({ type: GET_PROJECT_KANBAN_VIEW_INIT });
    getKanbanDataAPI(id)
      .then((response) =>
        dispatch({ type: GET_PROJECT_KANBAN_VIEW_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_PROJECT_KANBAN_VIEW_FAILED, error })
      );
  };
}

export function emptyKanbanData(response) {
  return (dispatch) => {
    dispatch({ type: GET_PROJECT_KANBAN_VIEW_SUCCESS, response });
  };
}

export function emptyProjectDetails(response) {
  return (dispatch) => {
    dispatch({ type: GET_PROJECT_DETAILS_BY_ID_SUCCESS, response });
  };
}

export function getKanbanResourceData(id) {
  return (dispatch) => {
    dispatch({ type: GET_PROJECT_KANBAN_RESOURCE_INIT });
    getKanbanResourceDataAPI(id)
      .then((response) =>
        dispatch({ type: GET_PROJECT_KANBAN_RESOURCE_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_PROJECT_KANBAN_RESOURCE_FAILED, error })
      );
  };
}

export function addResource(body) {
  return (dispatch) => {
    dispatch({ type: ADD_RESOURCE_INIT });
    addResourceAPI(body)
      .then((response) => dispatch({ type: ADD_RESOURCE_SUCCESS, response }))
      .catch((error) => dispatch({ type: ADD_RESOURCE_FAILED, error }));
  };
}
export function resourceRequests(body) {
  return (dispatch) => {
    dispatch({ type: ADD_RESOURCE_REQUESTS_INIT });
    addResourceRequestsAPI(body)
      .then((response) =>
        dispatch({ type: ADD_RESOURCE_REQUESTS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: ADD_RESOURCE_REQUESTS_FAILED, error })
      );
  };
}

export function removeResource(mapId) {
  return (dispatch) => {
    dispatch({ type: REMOVE_RESOURCE_INIT });
    removeResourceAPI(mapId)
      .then((response) => dispatch({ type: REMOVE_RESOURCE_SUCCESS, response }))
      .catch((error) => dispatch({ type: REMOVE_RESOURCE_FAILED, error }));
  };
}

export const getAddResourceBySkillRoleId = (roles, skills, dates) => {
  return (dispatch) => {
    dispatch({ type: GET_ADD_RESOURCE_INIT });
    return getAddResourceBySkillRoleIdAPI(roles, skills, dates)
      .then((response) => {
        dispatch({ type: GET_ADD_RESOURCE_SUCCESS, response });
        return response;
      })
      .catch((error) => {
        dispatch({ type: GET_ADD_RESOURCE_FAILED, error });
        return error;
      });
  };
};

export const getProjectList = () => {
  return (dispatch) => {
    dispatch({ type: GET_PROJECTS_LIST_INIT });
    return getProjectListAPI()
      .then((response) => {
        dispatch({ type: GET_PROJECTS_LIST_SUCCESS, response });
        return response;
      })
      .catch((error) => {
        dispatch({ type: GET_PROJECTS_LIST_FAILED, error });
        return error;
      });
  };
};

export const getResourceByResourceId = (resourceId, dates, mapId) => {
  return (dispatch) => {
    dispatch({ type: GET_RESOURCE_BY_ID_INIT });
    return getResourceByResourceIdAPI(resourceId, dates, mapId)
      .then((response) => {
        dispatch({ type: GET_RESOURCE_BY_ID_SUCCESS, response });
        return response;
      })
      .catch((error) => {
        dispatch({ type: GET_RESOURCE_BY_ID_FAILED, error });
        return error;
      });
  };
};

export function getPLStatementBudget(year, id) {
  return (dispatch) => {
    dispatch({ type: GET_PL_STATEMENT_BUDGET_INIT });
    getPLStatementBudgetAPI(year, id)
      .then((response) =>
        dispatch({
          type: GET_PL_STATEMENT_BUDGET_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_PL_STATEMENT_BUDGET_FAILED,
          error,
        })
      );
  };
}

export function getPLStatementForecast(year, projectId) {
  return (dispatch) => {
    dispatch({ type: GET_PL_STATEMENT_FORECAST_INIT });
    getPLStatementForecastAPI(year, projectId)
      .then((response) =>
        dispatch({
          type: GET_PL_STATEMENT_FORECAST_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_PL_STATEMENT_FORECAST_FAILED,
          error,
        })
      );
  };
}
export function getBudgetVsForecast(year, projectId) {
  return (dispatch) => {
    dispatch({ type: GET_BUDGET_FORECAST_INIT });
    getBudgetVsForecastAPI(year, projectId)
      .then((response) =>
        dispatch({
          type: GET_BUDGET_FORECAST_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_BUDGET_FORECAST_FAILED,
          error,
        })
      );
  };
}
export function getBreakdownChart(year, projectId) {
  return (dispatch) => {
    dispatch({ type: GET_BREAKDOWN_CHART_INIT });
    getBreakdownChartAPI(year, projectId)
      .then((response) => {
        dispatch({
          type: GET_BREAKDOWN_CHART_SUCCESS,
          response,
        });
      })
      .catch((error) =>
        dispatch({
          type: GET_BREAKDOWN_CHART_FAILED,
          error,
        })
      );
  };
}
export function getTotalCost(body) {
  return (dispatch) => {
    dispatch({ type: GET_TOTAL_COST_INIT });
    getTotalCostAPI(body)
      .then((response) => dispatch({ type: GET_TOTAL_COST_SUCCESS, response }))
      .catch((error) => dispatch({ type: GET_TOTAL_COST_FAILED, error }));
  };
}
export function getTotalBudget(body) {
  return (dispatch) => {
    dispatch({ type: GET_TOTAL_BUDGET_INIT });
    getTotalBudgetAPI(body)
      .then((response) =>
        dispatch({ type: GET_TOTAL_BUDGET_SUCCESS, response })
      )
      .catch((error) => dispatch({ type: GET_TOTAL_BUDGET_FAILED, error }));
  };
}

export function downloadProjectAnalytics(body, myView, showInactiveProjects) {
  return (dispatch) => {
    dispatch({ type: DOWNLOAD_PROJECT_ANALYTICS_INIT });
    downloadProjectAnalyticsAPI(body, myView, showInactiveProjects)
      .then((response) =>
        dispatch({ type: DOWNLOAD_PROJECT_ANALYTICS_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: DOWNLOAD_PROJECT_ANALYTICS_FAILED, error })
      );
  };
}

export function getNamedAllocatedResourceDetails(year, projectId, frequency) {
  return (dispatch) => {
    dispatch({ type: GET_NAMED_RESOURCES_ALLOCATIONS_INIT });
    getNamedAllocatedResourceDetailsAPI(year, projectId, frequency)
      .then((response) =>
        dispatch({
          type: GET_NAMED_RESOURCES_ALLOCATIONS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_NAMED_RESOURCES_ALLOCATIONS_FAILED,
          error,
        })
      );
  };
}

export function getNamedAllocatedResourceDetailsByMapId(
  year,
  projectId,
  frequency,
  mapId
) {
  return (dispatch) => {
    dispatch({ type: GET_NAMED_ALLOCATIONS_BY_MAPID_INIT });
    getNamedAllocatedResourceDetailsByMapIdAPI(
      year,
      projectId,
      frequency,
      mapId
    )
      .then((response) =>
        dispatch({
          type: GET_NAMED_ALLOCATIONS_BY_MAPIDT_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_NAMED_ALLOCATIONS_BY_MAPID_FAILED,
          error,
        })
      );
  };
}

export function acceptCompleteResourceRequestProject(mapId, body) {
  return (dispatch) => {
    dispatch({ type: ACCEPT_PROJECT_REQUEST_INIT });
    acceptCompleteResourceRequestAPI(mapId, body)
      .then((response) =>
        dispatch({
          type: ACCEPT_PROJECT_REQUEST_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: ACCEPT_PROJECT_REQUEST_FAILED,
          error,
        })
      );
  };
}

export function getUnnamedAllocatedResourceDetails(year, projectId, frequency) {
  return (dispatch) => {
    dispatch({ type: GET_UNNAMED_RESOURCES_ALLOCATIONS_INIT });
    getUnnamedAllocatedResourceDetailsAPI(year, projectId, frequency)
      .then((response) =>
        dispatch({
          type: GET_UNNAMED_RESOURCES_ALLOCATIONS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_UNNAMED_RESOURCES_ALLOCATIONS_FAILED,
          error,
        })
      );
  };
}

export function updateNamedAllocatedResourceDetails(
  body,
  year,
  freuency,
  projectId,
  goBeyondAvailableFteLimit = true
) {
  return (dispatch) => {
    dispatch({ type: UPDATE_NAMED_RESOURCES_ALLOCATIONS_INIT });
    updateNamedAllocatedResourceDetailsAPI(
      body,
      year,
      freuency,
      projectId,
      goBeyondAvailableFteLimit
    )
      .then((response) =>
        dispatch({
          type: UPDATE_NAMED_RESOURCES_ALLOCATIONS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: UPDATE_NAMED_RESOURCES_ALLOCATIONS_FAILED,
          error,
        })
      );
  };
}

export function updateUnnamedAllocatedResourceDetails(
  body,
  year,
  freuency,
  projectId,
  goBeyondAvailableFteLimit = true
) {
  return (dispatch) => {
    dispatch({ type: UPDATE_UNNAMED_RESOURCES_ALLOCATIONS_INIT });
    updateUnnamedAllocatedResourceDetailsAPI(
      body,
      year,
      freuency,
      projectId,
      goBeyondAvailableFteLimit
    )
      .then((response) =>
        dispatch({
          type: UPDATE_UNNAMED_RESOURCES_ALLOCATIONS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: UPDATE_UNNAMED_RESOURCES_ALLOCATIONS_FAILED,
          error,
        })
      );
  };
}

export function addToProjectNamed(body, year, freuency, projectId) {
  return (dispatch) => {
    dispatch({ type: ADD_TO_PROJECT_NAMED_INIT });
    addToProjectNamedAPI(body, year, freuency, projectId)
      .then((response) =>
        dispatch({
          type: ADD_TO_PROJECT_NAMED_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: ADD_TO_PROJECT_NAMED_FAILED,
          error,
        })
      );
  };
}

export function addToProjectUnnamed(
  body,
  year,
  freuency,
  projectId,
  goBeyondAvailableFteLimit = true
) {
  return (dispatch) => {
    dispatch({ type: ADD_TO_PROJECT_UNNAMED_INIT });
    addToProjectUnnamedAPI(
      body,
      year,
      freuency,
      projectId,
      goBeyondAvailableFteLimit
    )
      .then((response) =>
        dispatch({
          type: ADD_TO_PROJECT_UNNAMED_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: ADD_TO_PROJECT_UNNAMED_FAILED,
          error,
        })
      );
  };
}

export function getRequestResourceByFilters(body) {
  return (dispatch) => {
    dispatch({ type: GET_REQUEST_RESOURCES_BY_FILTERS_INIT });
    getRequestResourceByFiltersAPI(body)
      .then((response) =>
        dispatch({
          type: GET_REQUEST_RESOURCES_BY_FILTERS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_REQUEST_RESOURCES_BY_FILTERS_FAILED,
          error,
        })
      );
  };
}

export function emptyResourceByFilters(response) {
  return (dispatch) => {
    dispatch({ type: GET_REQUEST_RESOURCES_BY_FILTERS_SUCCESS, response });
  };
}

export function getRequestResourceByFiltersByRM(body) {
  return (dispatch) => {
    dispatch({ type: GET_REQUEST_RESOURCES_BY_FILTERS_BY_RM_INIT });
    getRequestResourceByFiltersByRMAPI(body)
      .then((response) =>
        dispatch({
          type: GET_REQUEST_RESOURCES_BY_FILTERS_BY_RM_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_REQUEST_RESOURCES_BY_FILTERS_BY_RM_FAILED,
          error,
        })
      );
  };
}
export function getDownloadCreateProjectExcelFile() {
  return (dispatch) => {
    dispatch({ type: GET_DOWNLOAD_CREATE_PROJECT_INIT });
    getDownloadCreateProjectExcelFileAPI()
      .then((response) =>
        dispatch({
          type: GET_DOWNLOAD_CREATE_PROJECT_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_DOWNLOAD_CREATE_PROJECT_FAILED,
          error,
        })
      );
  };
}
export function createProjectFromExcel(body) {
  return (dispatch) => {
    dispatch({ type: CREATE_PROJECT_FROM_EXCEL_INIT });
    createProjectFromExcelAPI(body)
      .then((response) =>
        dispatch({
          type: CREATE_PROJECT_FROM_EXCEL_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: CREATE_PROJECT_FROM_EXCEL_FAILED, error })
      );
  };
}

export function updateProjectFavoritesStatus(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_FAVOURITE_STATUS_INIT });
    updateProjectFavoritesStatusAPI(body)
      .then((response) =>
        dispatch({
          type: UPDATE_FAVOURITE_STATUS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_FAVOURITE_STATUS_FAILED, error })
      );
  };
}

export function showAddNamedUnnamedResourceButtons(id) {
  return (dispatch) => {
    dispatch({ type: SHOW_NAMED_UNNAMED_BUTTON_INIT });
    showAddNamedUnnamedResourceButtonsAPI(id)
      .then((response) =>
        dispatch({
          type: SHOW_NAMED_UNNAMED_BUTTON_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: SHOW_NAMED_UNNAMED_BUTTON_FAILED, error })
      );
  };
}

export function downloadResourceDelinquenciesReport() {
  return (dispatch) => {
    dispatch({ type: DOWNLOAD_COMPLIANCE_REPORT_PROJECT_INIT });
    downloadResourceDelinquenciesReportAPI()
      .then((response) =>
        dispatch({
          type: DOWNLOAD_COMPLIANCE_REPORT_PROJECT_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: DOWNLOAD_COMPLIANCE_REPORT_PROJECT_FAILED, error })
      );
  };
}

export function getResourceDelinquenciesReport() {
  return (dispatch) => {
    dispatch({ type: COMPLIANCE_REPORT_PROJECT_INIT });
    getResourceDelinquenciesReportAPI()
      .then((response) =>
        dispatch({
          type: COMPLIANCE_REPORT_PROJECT_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: COMPLIANCE_REPORT_PROJECT_FAILED, error })
      );
  };
}

export function getAdminSupportActivitiesTable() {
  return (dispatch) => {
    dispatch({ type: GET_ADMIN_SUPPORT_ACTIVITIES_INIT });
    getAdminSupportActivitiesTableAPI()
      .then((response) =>
        dispatch({
          type: GET_ADMIN_SUPPORT_ACTIVITIES_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: GET_ADMIN_SUPPORT_ACTIVITIES_FAILED, error })
      );
  };
}

export function createUpdateAdminSupportActivity(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_ADMIN_SUPPORT_ACTIVITIES_INIT });
    createUpdateAdminSupportActivityAPI(body)
      .then((response) =>
        dispatch({
          type: UPDATE_ADMIN_SUPPORT_ACTIVITIES_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_ADMIN_SUPPORT_ACTIVITIES_FAILED, error })
      );
  };
}

export function downloadAdminSupportActivity() {
  return (dispatch) => {
    dispatch({ type: DOWNLOAD_ADMIN_SUPPORT_ACTIVITIES_INIT });
    downloadAdminSupportActivityAPI()
      .then((response) =>
        dispatch({
          type: DOWNLOAD_ADMIN_SUPPORT_ACTIVITIES_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: DOWNLOAD_ADMIN_SUPPORT_ACTIVITIES_FAILED, error })
      );
  };
}

export function clearAdminSupport() {
  return (dispatch) => {
    dispatch({ type: GET_ADMIN_SUPPORT_ACTIVITIES_INIT });
  };
}

export function createUpdateResourceAdminSupportActivity(
  body,
  forceDeallocateResources
) {
  return (dispatch) => {
    dispatch({ type: UPDATE_ADMIN_SUPPORT_RESOURCE_ACTIVITIES_INIT });
    createUpdateResourceAdminSupportActivityAPI(body, forceDeallocateResources)
      .then((response) =>
        dispatch({
          type: UPDATE_ADMIN_SUPPORT_RESOURCE_ACTIVITIES_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: UPDATE_ADMIN_SUPPORT_RESOURCE_ACTIVITIES_FAILED,
          error,
        })
      );
  };
}

export function downloadFilteredProjectAnalytics(
  body,
  myView,
  showInactiveProjects
) {
  return (dispatch) => {
    dispatch({ type: DOWNLOAD_FILTERED_PROJECT_ANALYTICS_INIT });
    downloadFilteredProjectAnalyticsAPI(body, myView, showInactiveProjects)
      .then((response) =>
        dispatch({
          type: DOWNLOAD_FILTERED_PROJECT_ANALYTICS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: DOWNLOAD_FILTERED_PROJECT_ANALYTICS_FAILED, error })
      );
  };
}

export function resetReports() {
  return (dispatch) => {
    dispatch({ type: COMPLIANCE_REPORT_PROJECT_INIT });
    dispatch({ type: COMPLIANCE_REPORT_RESOURCE_INIT });
    dispatch({ type: GET_USER_ACCESS_CHART_INIT });
    dispatch({ type: USER_ACCESS_REPORT_INIT });
  };
}

export function downloadProjectAllAllocationDataChart(
  projectId,
  allocationFrequency
) {
  return (dispatch) => {
    dispatch({ type: DOWNLOAD_PROJECT_RESOURCE_DATA_INIT });
    downloadProjectAllAllocationDataChartAPI(projectId, allocationFrequency)
      .then((response) =>
        dispatch({
          type: DOWNLOAD_PROJECT_RESOURCE_DATA_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: DOWNLOAD_PROJECT_RESOURCE_DATA_FAILED, error })
      );
  };
}
